<template>
  <div class="table">
    <table>
      <table-header v-if="showHeader" ref="tableHeader" :columns="columns"></table-header>
      <table-body v-if="data.length > 0" ref="bodyWrapper" :stripe="stripe" :row-class-name="rowClassName"
        :row-style="rowStyle" :style="{
          width: bodyWidth
        }" :columns="columns" :data="data">
      </table-body>
    </table>
    <p v-if="data.length == 0" class="empty-data">暂无数据</p>
  </div>
</template>
 
<script>
import TableHeader from './tableHeader.vue';
import TableBody from './tableBody.vue';

export default {
  name: 'yssTable',
  components: {
    TableHeader,
    TableBody
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    stripe: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: String,
      default: ''
    },
    rowStyle: {
      type: Object,
      default: () => { }
    },
    bodyWidth: {
      type: Number,
      default: null
    },
    emptyBlockStyle: {
      type: Object,
      default: () => { }
    },
    emptyText: {
      type: String,
      default: ''
    }
  }
};
</script>
 
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.14rem;
}

.empty-data {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 15px;
}
</style>